module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pressTabList2"
  }, [(_vm.opMsg && _vm.role == 'show') ? _c('div', {
    staticClass: "rejects"
  }, [_c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm._f("filterMsgStatus")(_vm.msgStatus)))])]), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, _vm._l(((_vm.opMsg || '').split('；')), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("\n            " + _vm._s(item ? item + (index == (_vm.opMsg || "").split("；").length - 1 ? "" : "；") : "") + "\n          ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("材料1：工作总结")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.toCancel
    }
  }, [(_vm.cancelFlag) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    }
  }, [_vm._v("撤 回")]) : _vm._e()], 1)]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabCage.tabDat1,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialTitle",
      "label": "材料名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完成进度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.status, "pgress")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.updatedAt, "time")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          }
        }, [_c('a', {
          attrs: {
            "download": ""
          },
          on: {
            "click": function($event) {
              _vm.filesDown(scope.row)
            }
          }
        }, [_vm._v("下载")])]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("材料2：音像制品出版单位年度核验表、音像制品出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("材料2：电子出版物出版单位年度核验表、电子出版物出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 1) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl1,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl2,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表1：音像制品出版单位年度核验表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表1：电子出版物出版单位年度核验表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tabCage.tabDat2), function(item, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v("1-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.updatedAt, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), (inx == 0) ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "7"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : (inx == 7) ? _c('td', [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表2：音像制品出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表2：电子出版物出版情况表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.tabCage.tabDat3), function(item, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v("2-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.updatedAt, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(3)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)])])
  })], 2)]), _vm._v(" "), (_vm.role == 'press') ? _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(2), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "250",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "min-width": "300",
      "label": "审核意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l(((scope.row.examineMessage || '').split('；')), function(item, index) {
          return _c('div', {
            key: index,
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._v("\n              " + _vm._s(item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "") + "\n            ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "150",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("流转记录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-370433cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/SpecCommonTab.vue
// module id = 1711
// module chunks = 1